<div class="object-properties-container">
  <div class="header">
    <h3>Object Properties Configuration</h3>
    <p class="subtitle">Manage configuration properties for this account. Property names are read-only, values must be valid JSON.</p>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <div class="loading-spinner"></div>
    <span>Loading object properties...</span>
  </div>

  <!-- Empty State -->
  <div *ngIf="!isLoading && objectProperties.length === 0" class="empty-state">
    <i class="material-icons">settings</i>
    <h4>No Object Properties Found</h4>
    <p>There are no object properties configured for this account yet.</p>
  </div>

  <!-- Properties List -->
  <div *ngIf="!isLoading && objectProperties.length > 0" class="properties-list">
    <div class="properties-grid">
      <div class="grid-header">
        <div class="grid-cell header-cell">Property Name</div>
        <div class="grid-cell header-cell">JSON Value</div>
        <div class="grid-cell header-cell actions-header">Actions</div>
      </div>

      <div 
        class="property-row" 
        *ngFor="let property of objectProperties; trackBy: trackByPropertyId"
        [class.editing]="isEditing(property.id)"
        [class.error]="hasJsonError(property.id)"
      >
        <!-- Property Name (Read-only) -->
        <div class="grid-cell name-cell">
          <div class="property-name">
            <i class="material-icons">vpn_key</i>
            <span class="name-text" [title]="property.key">{{ property.key }}</span>
          </div>
          <div class="property-metadata">
            <small>ID: {{ property.id }}</small>
          </div>
        </div>

        <!-- Property Value -->
        <div class="grid-cell value-cell">
          <!-- Display Mode -->
          <div *ngIf="!isEditing(property.id)" class="value-display">
            <pre class="json-display" [class.empty]="!property.value">{{ getDisplayValue(property.value) }}</pre>
          </div>

          <!-- Edit Mode -->
          <div *ngIf="isEditing(property.id)" class="value-edit">
            <textarea
              class="json-editor"
              [value]="property.value"
              (input)="onJsonChange(property.id, $event.target.value)"
              placeholder="Enter valid JSON..."
              rows="8"
              spellcheck="false"
            ></textarea>
            
            <!-- JSON Validation Error -->
            <div *ngIf="hasJsonError(property.id)" class="error-message">
              <i class="material-icons">error</i>
              {{ getJsonError(property.id) }}
            </div>
          </div>
        </div>

        <!-- Actions -->
        <div class="grid-cell actions-cell">
          <div class="action-buttons">
            <!-- Edit Mode Actions -->
            <div *ngIf="isEditing(property.id)" class="edit-actions">
              <mrs-btn-primary 
                buttonLabel="Save"
                iconName="check"
                iconPosition="before"
                [disabled]="hasJsonError(property.id)"
                (onClick)="toggleEdit(property.id); saveObjectProperties();"
              ></mrs-btn-primary>
              <mrs-btn-outline 
                buttonLabel="Cancel"
                iconName="close"
                (onClick)="cancelEdit(property.id)"
              ></mrs-btn-outline>
            </div>

            <!-- Display Mode Actions -->
            <div *ngIf="!isEditing(property.id)" class="display-actions">
              <mrs-btn-primary 
                buttonLabel="Edit"
                iconName="edit"
                iconPosition="before"
                (onClick)="toggleEdit(property.id)"
              ></mrs-btn-primary>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
